// Compliance badges for the footer: ISO 27001 and GDPR, using the badge
// artwork in /public/badges.

export function ComplianceBadges() {
  return (
    <div className="mt-6 flex items-center gap-4">
      <img
        src="/badges/iso-27001.png"
        alt="ISO 27001 certified"
        className="h-14 w-14 shrink-0 object-contain"
        loading="lazy"
      />
      <img
        src="/badges/gdpr-compliant.webp"
        alt="GDPR compliant"
        className="h-14 w-14 shrink-0 object-contain"
        loading="lazy"
      />
    </div>
  )
}
